import { TransformInt } from '../../../decorators/transform-int.decorator';

import { CreateVehicleModelDto } from './create-vehicle-model.dto';

/**
 * Update vehicle model DTO
 */
export class UpdateVehicleModelDto extends CreateVehicleModelDto {
	@TransformInt()
	id!: number;
}
